import { FC } from 'react';

import { Icon, IconName, Size } from '@purpur/library/icon';

import { getSvgIcon } from '@telialt/common-icon/src';

import { RoundFilledIconWrapper } from './RoundFilledIcon.styles';

type Props = { icon?: IconName | string; size: Size };

export const RoundFilledIcon: FC<Props> = ({ icon, size }) => {
    const svg = getSvgIcon(icon);

    return (
        <RoundFilledIconWrapper>
            <Icon svg={svg} size={size} />
        </RoundFilledIconWrapper>
    );
};
